// Module
var code = "<div class=\"ToolBarPreview\"> <label data-bind=\"attr: { title: Label }\"> <i class=\"fa fa-columns\"></i> <!--ko text: Label--><!--/ko--> </label> </div>";
// Exports
export default code;